/**
 * In-memory source-cache adapter (process / tab lifetime).
 */

import type { SourceCacheAdapter, SourceCacheEntry } from './types';

export function createMemoryAdapter(): SourceCacheAdapter {
  const store = new Map<string, SourceCacheEntry<unknown>>();

  return {
    get<T>(key: string): SourceCacheEntry<T> | null {
      const hit = store.get(key);
      return hit ? (hit as SourceCacheEntry<T>) : null;
    },
    set<T>(key: string, entry: SourceCacheEntry<T>): void {
      store.set(key, entry as SourceCacheEntry<unknown>);
    },
    delete(key: string): void {
      store.delete(key);
    },
    clear(): void {
      store.clear();
    },
  };
}
